<template>
    <div class="chat__room-item-main">
        <div class = "chat__room-item-data-wrap-main">
            <div class="chat__room-item-data" @click="enterRoom(roomId, roomTitle)">
                <div v-if="typeRoom === 'public'" class="chat__room-item-data-img f-ava">
                    <img :src="avatarRoom" class="f-ava__img">
                </div>
                <div v-if="typeRoom === 'private'" class="chat__room-item-data-img">
                    <userAvatar :userLogin="roomId"/>
                </div>
                <div class="chat__room-item-data-name" >
                    <a href="#" >
                        {{roomTitle}}
                    </a>
                    <div v-if="typeRoom === 'public'" class="chat__room-item-data-users">
                        {{getInfoForRoom.cnt}} участников
                    </div>
                    <div v-if="typeRoom === 'private'" class="chat__room-item-data-users">
                        {{subtitle}}
                    </div>
                    <div><a :href="'mailto:' + mail">{{mail}}</a></div>
                    <div>{{tel}}</div>
                </div>
            </div>
            <div class="chat__room-item-data-return" v-if="typeWidget ==='widget' && roomId === currentRoom"  @click="returnRoom()">
                <div class="chat__room-item-data-return_text">Назад</div>
            </div>
            <div class="chat__room-item-data-status" v-if="getInfoForRoom.newMessages">
                <div class="chat__room-item-data-alert">
                    <!--<span v-if="getInfoForRoom.cntUnreadMsg !== 0">{{getInfoForRoom.cntUnreadMsg}}</span>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import userAvatar from '../ui-components/chat-avatar';
export default {
    components: {
        userAvatar
    },
    data() {
        return {
            currentRoom:''
        }
    },
    props: {
        roomId:{default:'general'},
        avatarRoom:{default:require('../../assets/img/common_room.png')},
        roomTitle:{default:'Общая'},
        typeRoom:{default:'public'},
        subtitle:{default:''},
        typeWidget:{default:'chat'},
        mail:{default:''},
        tel:{default:''}
    },
    computed: {
        ...mapGetters({
            infoRoom:'chat/getUsersInRoom',
            readyStatus:'chat/getStatusReadyRoomInf',
            currentRoomId: 'chat/currentRoomId',
            getLogin: 'auth/getInfoUser',
        }),
        getInfoForRoom() {
            let info = {
                cnt:0,
                lastMessage:new Date(),
                type:'',
                cntUnreadMsg:0,
                readStatus:true
            };
            if (this.infoRoom.length !== 0)
                for(let i = 0; i < this.infoRoom.length; i++) {
                    if(this.roomId === this.infoRoom[i].idRoom) {
                        info.cnt = this.infoRoom[i].cnt;
                        info.lastMessage =  this.infoRoom[i].lastMessage;
                        info.newMessages = this.infoRoom[i].newMessages;
                        info.type = this.infoRoom[i].type;
                        info.cntUnreadMsg = this.infoRoom[i].cntUnreadMsg
                    }
                }
            return info;
        },
    },
    methods: {
        enterRoom(roomId, roomName) {
            this.$store.commit('chat/setCurrentRoomName', roomName);
            this.typeRoom === 'public' ? this.$store.dispatch('chat/enterRoom', roomId) : this.$store.dispatch('chat/enterDirectRoom',roomId);
            this.$store.commit('chat/setReadStatus', this.roomId);
            this.$emit('setRoom', roomId);
            this.currentRoom = roomId;
        },
        returnRoom() {
            this.$emit('return');
            this.currentRoom = '';
        }
    },
    watch: {
        getInfoForRoom: function (value) {
            if(value.newMessages) {
                const myAudio = new Audio;
                myAudio.src = (require("../../assets/sound/chat-alert.mp3"));
                let promise = myAudio.play();
                if (promise !== undefined) {
                    promise.then(_ => {
                    //Auto
                    myAudio.play();
                    }).catch(error => {
                    });
                }
            }
        },
        getLogin: function() {
            this.currentRoom = '';
        }
    }
}
</script>
<style lang="less" scoped>
 .chat__room {
    &-item {
        &-main {
            display: flex;
            cursor: pointer;
            background: #374b62;
            min-width: 360px;
        }
        &-data-wrap-main {
            display: flex;
            flex-grow: 1;
            border-bottom: 1px solid #324258;
            box-sizing: border-box;
        }
        &-data {
            flex-grow: 1;
            display: flex;
            padding: 12px;
            &-return {
                display:flex;
                align-items: center;
                padding-right: 12px;
                cursor: pointer;
                margin-left: auto;
                i {
                    font-size: 23px;
                    color: #a1b7cc;
                }
                &_text {
                    font-family: Arimo;
                    font-size: 13px;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.54;
                    letter-spacing: 0.4px;
                    text-align: left;
                    color: #a1b7cc;
                    text-decoration: none;
                    text-transform: uppercase;
                }
            }
            &-img {
                margin-right: 16px;
            }
            &-users {
                font-family: Arimo;
                font-size: 13px;
                font-weight: 400;
                color:#a1b7cc;
                line-height: 1.54;
            }
            &-name a {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
                text-align: left;
                color: #ffffff;
                text-decoration: none;
                text-transform: uppercase;
            }
            &-status {
                display: flex;
                align-items: center;
                margin-left: auto;
                padding-right: 23px;
            }
            &-alert {
                background: @colors[green];
                border-radius: 18px;
                text-align: center;
                color:#324258;
                width: 23px;
                height: 23px;
                padding-top: 4px;
                box-sizing: border-box;
                span {
                    display: block;
                    font-family: Arimo;
                    font-size: 12px;
                    margin: auto;
                }
            }
        }
    }
}
</style>
